import React, { useContext, useEffect, useState } from 'react';

const Notice = () => {
  return <div>Notice</div>;
};

export default Notice;
